import { render, staticRenderFns } from "./SendIndicationsPhotoMainMenu.vue?vue&type=template&id=248b24ce"
import script from "./SendIndicationsPhotoMainMenu.vue?vue&type=script&lang=js"
export * from "./SendIndicationsPhotoMainMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports